<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="3">
        <v-autocomplete
          v-model="formData.kode_nota"
          :items="kodeNotaOptions"
          label="Kode Nota"
          outlined
          clearable
          dense
          autofocus
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn color="primary" @click="fetchLaporan">
          Cari
        </v-btn>
      </v-col>
    </v-row>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <p v-if="state.noData">No Data</p>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="header">
        <div class="left">
          <h2 class="report-title">LAPORAN BELUM LUNAS PER CUSTOMER</h2>
        </div>
      </div>

      <!-- Grouped by Kode Nota -->
      <div class="mt-4" v-if="!formData.kode_nota">
        <div v-for="(group, idx) in data" :key="idx" class="mb-5">
          <h2 class="kode-nota-title">Kode Nota: {{ group.kode_nota }}</h2>

          <div
            v-for="(customerGroup, cidx) in group.groups"
            :key="cidx"
            class="mb-3 ml-2"
          >
            <h3>{{ customerGroup.customer.nama }}</h3>
            <table width="100%">
              <colgroup>
                <col style="width: 35%" />
                <col style="width: 20%" />
                <col style="width: 20%" />
                <col style="width: 25%" />
              </colgroup>
              <thead>
                <th class="text-left">Nama Customer</th>
                <th class="text-left">Tanggal Nota</th>
                <th class="text-right">Nilai Nota</th>
                <th class="text-left">Keterangan Nota</th>
              </thead>
              <tbody>
                <tr v-for="item in customerGroup.items" :key="item.id">
                  <td class="text-left">{{ customerGroup.customer.nama }}</td>
                  <td class="text-left">{{ formatDate(item.tgl_nota) }}</td>
                  <td class="text-right">
                    {{ formatCurrency(item.nilai_nota) }}
                  </td>
                  <td class="text-left">{{ item.keterangan_barang || "-" }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2" class="text-right"><b>Total:</b></td>
                  <td class="text-right">
                    <b>{{ formatCurrency(customerGroup.total_customer) }}</b>
                  </td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>

      <!-- Filtered by single Kode Nota -->
      <div class="mt-4" v-else>
        <h2>Kode Nota: {{ formData.kode_nota }}</h2>
        <div v-for="(customerGroup, cidx) in data" :key="cidx" class="mb-3">
          <h3>{{ customerGroup.customer.nama }}</h3>
          <table width="100%">
            <colgroup>
              <col style="width: 35%" />
              <col style="width: 20%" />
              <col style="width: 20%" />
              <col style="width: 25%" />
            </colgroup>
            <thead>
              <th class="text-left">Nama Customer</th>
              <th class="text-left">Tanggal Nota</th>
              <th class="text-right">Nilai Nota</th>
              <th class="text-left">Keterangan Nota</th>
            </thead>
            <tbody>
              <tr v-for="item in customerGroup.items" :key="item.id">
                <td class="text-left">{{ customerGroup.customer.nama }}</td>
                <td class="text-left">{{ formatDate(item.tgl_nota) }}</td>
                <td class="text-right">
                  {{ formatCurrency(item.nilai_nota) }}
                </td>
                <td class="text-left">{{ item.keterangan_barang || "-" }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="2" class="text-right"><b>Total:</b></td>
                <td class="text-right">
                  <b>{{ formatCurrency(customerGroup.total_customer) }}</b>
                </td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </main>

    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: true
      },
      formData: {
        kode_nota: ""
      },
      kodeNotaOptions: [
        { text: "P", value: "P" },
        { text: "L", value: "L" },
        { text: "ND", value: "ND" }
      ],
      data: []
    };
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchLaporan() {
      this.state.loading = true;

      const params = new URLSearchParams();
      if (this.formData.kode_nota) {
        params.append("kode_nota", this.formData.kode_nota);
      }

      const query = params.toString();

      await axios
        .get(
          `invoice/laporan-belum-lunas-per-customer${query ? `?${query}` : ""}`
        )
        .then(res => {
          if (!res.data || res.data.length === 0) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }
          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;
          alert(err.response?.data?.message || "Gagal memuat laporan");
        });
    },
    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      if (Number.isNaN(d.getTime())) return "-";
      return `${String(d.getDate()).padStart(2, "0")}-${String(
        d.getMonth() + 1
      ).padStart(2, "0")}-${d.getFullYear()}`;
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num || 0);
    }
  },
  created() {
    this.fetchLaporan();
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.kode-nota-title {
  border-bottom: 2px solid #333;
  padding-bottom: 4px;
  margin-bottom: 10px;
}

.report table {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}

.report table th,
.report table td {
  border: 1px solid black;
  padding: 4px 8px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.report table tfoot td {
  border: 1px solid black;
}
</style>
